import React, {useId} from 'react';
import { Form } from 'react-bootstrap';

const ToggleSwitch = ({ name, label, register, errors, setValue, onUpdate }) => {
    const toggleId = useId();

    const handleChange = (e) => {
        const newValue = e.target.checked;

        setValue(name, newValue, { shouldValidate: true });

        if (onUpdate) {
            onUpdate(newValue);
        }
    };

    return (
        <Form.Group class="d-flex align-items-center gap-3">
            <span class="form-toggle-lable">{label}</span>
            <Form.Check
                type="switch"
                id={toggleId}
                {...register(name, { onChange: handleChange })}
                className="text-center m-0 form-toggle-large"
                isInvalid={!!errors[name]}
                style={{ color: '#4DA8B7' }}
            />
            {errors[name] && (
                <Form.Control.Feedback type="invalid">
                    {errors[name].message}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};

export default ToggleSwitch;